var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandRockBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Icon_awesome-hand-rock",
    className: "st0",
    d: "M31.8,6.5c-1.8,0-3.3,1.5-3.3,3.5c0,0,0,0,0,0.1h-0.5V7.8c0-1.9-1.4-3.5-3.2-3.6 c-1.8,0-3.3,1.5-3.3,3.5c0,0,0,0,0,0.1v2.4h-0.5V6.6c0-1.9-1.4-3.5-3.2-3.6c-1.8,0-3.3,1.5-3.3,3.5c0,0,0,0,0,0.1v3.5h-0.5V7.8 c0-1.9-1.4-3.5-3.2-3.6c-1.8,0-3.3,1.5-3.3,3.5c0,0,0,0,0,0.1v10l-0.5-0.5v-3.5c0-1.9-1.4-3.5-3.2-3.6C1.5,10,0,11.6,0,13.5 c0,0,0,0,0,0.1v4.9c0,2,0.8,3.9,2.2,5.3l7.6,7.3c0.7,0.7,1.1,1.6,1.1,2.6v0.5c0,1,0.7,1.8,1.6,1.8c0,0,0,0,0,0H29 c0.9,0,1.6-0.8,1.6-1.8c0,0,0,0,0,0V34c0-0.9,0.2-1.9,0.5-2.7l3.3-8.6c0.3-0.9,0.5-1.8,0.5-2.7v-9.8C35,8.2,33.6,6.6,31.8,6.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandRockBlu);
export default __webpack_public_path__ + "static/media/hand-rock-blu.bdea8f29.svg";
export { ForwardRef as ReactComponent };